import styles from './styles.module.scss';
import clsx from 'clsx';

interface Props extends React.HTMLAttributes<HTMLDivElement> {}

const Cloth = ({ className, ...props }: Props) => <div className={clsx(styles.root, className)} {...props} />;

export default Cloth;
